<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card>
                <v-card-title style="background: #eee" class="subheading mb-0">
                  <h4>Customers</h4>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-card-text>
                  <h5>
                    rating key: top 10 = 3 stars , next 50 = 2 stars, rest= 1
                    star
                  </h5>
                  <v-data-table
                    :headers="cust_headers"
                    :items="customers"
                    class="elevation-0"
                    :search="search"
                    :loading="loading"
                  >
                    <template v-slot:item.cust_phone="{ item }">
                      {{ item.cust_phone ? item.cust_phone : "N/A" }}
                    </template>

                  <template v-slot:item.rating="{ item,index }">
                       <v-icon color="#ffd700" v-if="rating(index) == 3"
                          >star</v-icon
                        >
                        <v-icon
                          v-if="
                            rating(index) == 2 || rating(index) == 3
                          "
                          >star</v-icon
                        >
                        <v-icon
                          color="#b08d57"
                          v-if="
                            rating(index) == 1 ||
                            rating(index) == 2 ||
                            rating(index) == 3
                          "
                          >star</v-icon
                        >
                    </template>

                     <template v-slot:item.trans_count="{ item }">
                      {{ item.trans_count ? item.trans_count : "N/A" }}
                    </template>

                     <template v-slot:item.cust_address="{ item }">
                      {{ item.cust_address ? item.cust_address : "N/A" }}
                    </template>

                    <!-- <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.cust_name }}</td>
                      <td class="text-xs-center">
                        {{
                          props.item.cust_phone ? props.item.cust_phone : "N/A"
                        }}
                      </td>
                      <td class="text-xs-center">
                        <v-icon color="#ffd700" v-if="rating(props.index) == 3"
                          >star</v-icon
                        >
                        <v-icon
                          v-if="
                            rating(props.index) == 2 || rating(props.index) == 3
                          "
                          >star</v-icon
                        >
                        <v-icon
                          color="#b08d57"
                          v-if="
                            rating(props.index) == 1 ||
                            rating(props.index) == 2 ||
                            rating(props.index) == 3
                          "
                          >star</v-icon
                        >
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item.trans_count ? props.item.trans_count : "0"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item.cust_address
                            ? props.item.cust_address
                            : "N/A"
                        }}
                      </td>
                    
                    </template> -->
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import UserService from "../../services/user-service";
import modalDialog from "../shared/modal_dialog";
import snackbar from "../shared/snackbar";
export default {
  components: {
    modalDialog,
    snackbar,
  },
  data() {
    return {
      valid: true,
      lazy: false,
      show1: false,
      busy: false,
      rules: {
        required: [(value) => !!value || "Required."],
        min: (v) => v.length >= 8 || "Min 8 characters",
      },

      search: "",
      editedIndex: -1,
      acc_status: false,
      dialog: false,
      cust_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "cust_name",
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "cust_name",
        },
        {
          text: "Phone No.",
          align: "center",
          sortable: false,
          value: "cust_phone",
        },
        {
          text: "Rating",
          align: "center",
          sortable: false,
          value: "rating",
        },
        {
          text: "Transactions",
          align: "center",
          sortable: false,
          value: "trans_count",
        },
        {
          text: "Address/Location",
          align: "center",
          sortable: false,
          value: "cust_address",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("Customers/getAll");
  },
  methods: {
    sendMessage(contact) {},
    rating(positionCount) {
      positionCount++;
      if (positionCount > 0 && positionCount <= 10) {
        return 3;
      } else if (positionCount > 10 && positionCount <= 50) {
        return 2;
      } else if (positionCount > 50) {
        return 1;
      }
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
  },
  computed: {
    ...mapGetters({
      customers: "Customers/CUSTOMERS",
      cerrors: "Customers/CUSTOMER_ERROR",
      loading: "Customers/CUSTOMER_LOADING",
    }),
  },
};
</script>